import DataGrid from "./DataGrid/DataGrid.tsx";

const SequentialPoliciesDataGrid = ({
  policies,
  isLoading,
  fromDate,
  toDate,
}: {
  policies: any[];
  isLoading: boolean;
  fromDate: string;
  toDate: string;
}) => {
  const dataSource = policies.map((policy) => ({
    ...policy,
    twoPercent: ((Number(policy.policySum) || 0) * 0.02).toFixed(2),
  }));

  const columns = [
    {
      name: "insuranceCompany",
      header: "ЗК",
      type: "string",
    },
    {
      name: "policyNumber",
      header: "№ Полица",
      type: "string",
    },
    {
      name: "policyType",
      header: "Вид",
      type: "string",
    },
    {
      name: "agent",
      header: "Агент",
      type: "string",
    },
    {
      name: "divisionName",
      header: "Офис",
      type: "string",
    },
    {
      name: "paymentDate",
      header: "Дата падеж",
      type: "string",
    },
    {
      name: "policySum",
      header: "Сума",
      type: "string",
    },
    {
      name: "twoPercent",
      header: "2%",
      type: "string",
    },
    {
      name: "installments",
      header: "Вноски",
      type: "number",
    },
    {
      name: "placeOfPayment",
      header: "Място плащане",
      type: "string",
    },
    {
      name: "vehicleRegistrationNumber",
      header: "Рег. №",
      type: "string",
    },
    {
      name: "vehicleBrand",
      header: "Марка",
      type: "string",
    },
    {
      name: "clientName",
      header: "Клиент",
      type: "string",
    },
    {
      name: "clientPhoneNumber",
      header: "Телефон",
      type: "string",
    },
    {
      name: "additionalPolicyData",
      header: "Допълнителна информация",
      minWidth: 250,
      type: "string",
    },
  ];

  return (
    <DataGrid
      columns={columns}
      dataSource={dataSource}
      isLoading={isLoading}
      gridTitle="Поредни вноски"
      idProperty="policyNumber"
      csvFilename={`Поредни-вноски-${fromDate}-${toDate}.csv`}
      icon="fa-kit fa-regular-file-circle-question"
    />
  );
};

export default SequentialPoliciesDataGrid;
